import script from "./DataCenterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCenterCard.vue?vue&type=script&setup=true&lang=js"

import "./DataCenterCard.vue?vue&type=style&index=0&id=1fe33bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe33bce"]])

export default __exports__